import { render } from "./ConfirmOrder.vue?vue&type=template&id=4f04ba8a&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=4f04ba8a&lang=scss&scoped=true"
import "./ConfirmOrder.vue?vue&type=style&index=1&id=4f04ba8a&lang=css"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f04ba8a"]])

export default __exports__